import { Link, Navigate } from 'react-router-dom'
import { Sparkles, ArrowLeft } from 'lucide-react'

import { AssistantWizard } from '@/components/AssistantWizard'
import { Button } from '@/components/ui/button'
import { useAuthStore } from '@/stores/auth'

/**
 * Story 3.18 — `/admin/prompts/assistant`.
 *
 * RBAC: admin + manager only (LLM cost gate). Other roles get redirected to
 * the regular prompts listing.
 */
export function PromptAssistantPage(): React.ReactElement {
  const role = useAuthStore((s) => s.user?.role)
  const canUse = role === 'admin' || role === 'manager'

  if (!canUse) {
    return <Navigate to="/admin/prompts" replace />
  }

  return (
    <div className="space-y-6">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <div className="flex items-center gap-2">
          <Button asChild variant="ghost" size="icon" aria-label="Voltar">
            <Link to="/admin/prompts">
              <ArrowLeft className="h-4 w-4" aria-hidden="true" />
            </Link>
          </Button>
          <div>
            <h1 className="flex items-center gap-2 text-2xl font-semibold tracking-tight">
              <Sparkles className="h-5 w-5" aria-hidden="true" />
              Prompt Assistant
            </h1>
            <p className="text-sm text-muted-foreground">
              Gere um prompt candidato a partir de objetivo, tom, restrições e exemplos. O
              modelo entrega uma sugestão que você pode refinar, editar manualmente, ou aplicar
              como nova versão.
            </p>
          </div>
        </div>
      </div>

      <AssistantWizard />
    </div>
  )
}

export default PromptAssistantPage
